import styles from "./index.module.css";
import { FaFacebookF, FaYoutube, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className="main-container">
                <div className="container-content">
                    <div className={styles.footerMid}>
                        <div className={styles.footerMidLeft}>
                            <div className={styles.footerMidLeftTop}>
                                <div className={styles.midItemWrapper}>
                                    <h5>OFFICE</h5>
                                    <div className={styles.midItem}>
                                        <h5>Meegalla Holdings (Pvt) Ltd</h5>
                                        <span>10, Wijerama Road</span>
                                        <span>Colombo 07</span>
                                    </div>
                                </div>
                                <div className={styles.midItemWrapper}>
                                    <h5>NEED HELP</h5>
                                    <div className={styles.midItem}>
                                        <h1>+94 77 775 7479</h1>
                                        {/* <span>support@ardillalabs.com</span> */}
                                    </div>
                                </div>
                            </div>
                            {/* <div className={`${styles.navLinks} ${styles.sitemapLinks}`}>
                                <a href="#">Sitemap</a>
                                <a href="#">Privacy Policy</a>
                                <a href="#">Condition of use</a>
                            </div> */}
                        </div>
                        <div className={styles.footerMidRight}>
                            <div>
                                <div className={styles.midItemWrapper}>
                                    <h5>KEEP IN TOUCH</h5>

                                    <div className={styles.midItem}>
                                        <form className={styles.emailForm}>
                                            <input
                                                placeholder="Enter your mail"
                                                type="email"
                                                name="email"
                                                required
                                            />
                                            <button type="submit">GO</button>
                                        </form>
                                        <span>Get latest updates and offers</span>
                                    </div>
                                </div>
                                <div className={styles.socialMediaIcons}>
                                    <a
                                        href="https://web.facebook.com/ardillalabs"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaFacebookF className={styles.icon} />
                                    </a>
                                    <a
                                        href="https://www.linkedin.com/company/ardilla-labs"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaLinkedinIn className={styles.icon} />
                                    </a>
                                    <a
                                        href="https://www.youtube.com/@Ardillalabs"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaYoutube className={styles.icon} />
                                    </a>
                                </div>
                                <div className={`${styles.navLinks} ${styles.sitemapLinksMobile}`}>
                                    <a href="#">Sitemap</a>
                                    <a href="#">Privacy Policy</a>
                                    <a href="#">Condition of use</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className={styles.navHr} />
                    <div className={`layout-wrapper ${styles.copyright}`}>
                        Meegalla Holdings (Pvt) Ltd : Design &
                        Developed by{" "}
                        <a
                            href="https://www.ardillalabs.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Ardillalabs
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;